import { Button } from '@monksflow/monks-ui';
import { CircleAlertIcon, CircleCheckIcon, SigmaIcon } from 'lucide-react';

import type { AgentTreeNodeDto } from '@inference.engine/api-client/web';
import { useTranslation } from 'react-i18next';

export function ToolRow({
  tool,
  isLast,
  onConfigure,
}: {
  tool: AgentTreeNodeDto['tools'][number];
  isLast: boolean;
  onConfigure: (toolId: string, ownerAgentId: string) => void;
}) {
  const { t } = useTranslation('admin');

  const badgeClasses = !tool.isConfigurable
    ? 'bg-muted text-muted-foreground'
    : tool.isConfigured
      ? 'bg-positive text-positive-foreground'
      : 'bg-destructive/10 text-destructive';

  return (
    <div
      className={`flex flex-row items-center justify-between px-5 py-3 hover:bg-accent ${
        isLast ? '' : 'border-b border-border'
      }`}
    >
      <div className="flex min-w-0 flex-row items-center gap-3">
        <span
          className={`ml-1 flex size-7 shrink-0 items-center justify-center rounded-md ${badgeClasses}`}
        >
          <SigmaIcon className="size-4" />
        </span>

        <div className="flex min-w-0 flex-col">
          <div className="flex flex-row items-center gap-1.5">
            <span className="truncate text-sm leading-5">{tool.toolName}</span>
            {tool.isConfigurable &&
              (tool.isConfigured ? (
                <CircleCheckIcon className="size-3.5 shrink-0 text-positive-foreground" />
              ) : (
                <CircleAlertIcon className="size-3.5 shrink-0 text-destructive" />
              ))}
          </div>
          {tool.toolId !== tool.toolName && (
            <span className="truncate text-[11px] leading-4 text-muted-foreground">
              {tool.toolId}
            </span>
          )}
        </div>
      </div>

      {tool.isConfigurable && (
        <Button
          type="button"
          variant={tool.isConfigured ? 'outline' : 'default'}
          size="sm"
          onClick={() => onConfigure(tool.toolId, tool.agentId)}
          className="ml-4 shrink-0"
        >
          {tool.isConfigured ? t('admin.toolRow.edit') : t('admin.toolRow.configure')}
        </Button>
      )}
    </div>
  );
}
